/**
 * Configuração do Firebase para autenticação
 * 
 * Para configurar:
 * 1. Acesse https://console.firebase.google.com/
 * 2. Crie um novo projeto ou use um existente
 * 3. Vá em Project Settings > General > Your apps
 * 4. Adicione um app Web e copie as credenciais
 * 5. Atualize as variáveis no arquivo .env
 */

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyD2T-d8n3qVLQvOe4hEp3FsD7D2KP_8J4M",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "atomic-digital.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "atomic-digital",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "atomic-digital.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789:web:abcdef"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar Authentication
export const auth = getAuth(app);

// Configurar provider do Google
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
